import { Skeleton, Stack, Typography } from "@mui/material";

export interface IGenerationLoadingProps {
  label: string;
  count?: number;
  total?: number;
}

export const GenerationLoading = ({ label, count = 0, total = 0 }: IGenerationLoadingProps) => (
  <Stack sx={{ gap: 2, mt: 2 }}>
    <Typography variant="subtitle1SemiBold" color="primary">
      {label}
      {total > 0 && ` : ${count}/${total}`}
    </Typography>
    <Skeleton variant="rounded" height={40} />
    <Stack direction="row" sx={{ gap: 2 }}>
      <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
      <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
    </Stack>
    <Skeleton variant="rounded" height={40} />
    <Stack direction="row" sx={{ gap: 2 }}>
      <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
      <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
    </Stack>
  </Stack>
);
